var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"25%"}},[_c('div',{staticClass:"eight",staticStyle:{"width":"100%  display: flex"}},[_c('span',[_vm._v("付款渠道")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"eight"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fa67941","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/statistics/components/income.vue
// module id = null
// module chunks = 